import { sessionItemKey } from '../providers/auth/AuthProvider.tsx'
import { envConfig } from '../providers/envConfig/envConfig.ts'

// Gets the JWT payload from session storage, if one exists.
export const getPayloadFromJwt = (): string | null => {
  const sessionItem = sessionStorage.getItem(sessionItemKey)
  if (!sessionItem) {
    return null
  }

  try {
    const { token } = JSON.parse(sessionItem)
    const [, payload] = token.split('.')
    return payload ?? null
  } catch {
    return null
  }
}

// Adds a fetch interceptor that appends the "x-verified-vpc-payload" header with the users current JWT payload for
// development against a locally running backend.
const applyLocalDevInterceptor = () => {
  if (!(envConfig.environment == 'local' && envConfig.enableVpcPayload)) {
    return
  }

  const originalFetch = window.fetch.bind(window)

  window.fetch = (input: RequestInfo | URL, req?: RequestInit) => {
    const payload = getPayloadFromJwt()

    return originalFetch(input, {
      ...req,
      headers: {
        ...req?.headers,
        ...(payload ? { 'x-verified-vpc-payload': payload } : {}),
      },
    })
  }
}

export default applyLocalDevInterceptor
